
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_170_999)","fill":"#13A344"}},[_c('path',{attrs:{"d":"M20.031 10.98a.382.382 0 00-.173-.042.458.458 0 00-.332.142l-.924.91a.422.422 0 00-.13.312v3.607c0 .625-.225 1.16-.678 1.605a2.24 2.24 0 01-1.63.668H4.157a2.24 2.24 0 01-1.631-.668 2.17 2.17 0 01-.678-1.605V4.091c0-.625.225-1.16.678-1.605a2.24 2.24 0 011.63-.668h12.008c.211 0 .428.029.65.085a.466.466 0 00.128.029.46.46 0 00.333-.142l.707-.696a.438.438 0 00.13-.412.432.432 0 00-.26-.327A4.028 4.028 0 0016.164 0H4.157C3.012 0 2.033.4 1.219 1.201.406 2.001 0 2.965 0 4.091V15.91C0 17.035.406 18 1.22 18.8c.812.8 1.791 1.2 2.936 1.2h12.007c1.145 0 2.124-.4 2.937-1.2.813-.8 1.22-1.764 1.22-2.89v-4.518c0-.198-.097-.336-.29-.412h.001z"}}),_c('path',{attrs:{"d":"M11.041 16.256a.192.192 0 01-.33.002c-1.249-2.096-4.704-6.723-4.704-6.723l-.687-.89a.253.253 0 01-.013-.018c-.305-.498.414-1.314 1.008-.948l.942.64 3.43 2.357c.084.058.198.04.26-.038 2.201-2.778 4.244-4.695 5.589-5.827 1.51-1.271 2.43-1.837 2.467-1.864C20.72 1.715 22.627.961 23.748.585c.203-.068.348.194.18.325 0 0-1.442 1.059-3.015 2.342-4.711 4.132-9.82 12.915-9.871 13.003z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_170_999"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v20H0z"}})])])])
          )
        }
      }
    